<template>
  <div class="col-lg-12">
    <CenterHeader :selected-menu-item="6" />

    <div class="tab-content">
      <div id="features" class="tab-pane active">
        <clip-loader v-if="loading" />

        <AdminFeatures
          v-if="!loading && features"
          :features="features"
          :center="{ id: centerId }"
          :manageable-only="true"
          :saved="savedCounter"
        />
        <div v-if="!loading && features" class="text-right">
          <button
            class="btn btn-primary mb-4"
            type="button"
            @click="saveFeatures()"
          >
            {{ lang.get("general.formSaveLabel") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import CenterHeader from "./CenterHeader.vue";
import AdminFeatures from "../Features/AdminFeatures.vue";
import { lang } from "../../i18n";
import { userErrorMessage } from "../../mixins/UserErrorMessage.vue";
import { onMounted, ref, toRefs } from "vue";
import { notify } from "@kyvg/vue3-notification";
import { practitionerHttpService } from "../../app/practitioner-portal/store/practitioner-http-service";

const props = defineProps<{
  centerId: number;
}>();
const { centerId } = toRefs(props);

const features = ref<Record<string, unknown> | null>(null);
const loading = ref(true);
const savedCounter = ref(0);

onMounted(() => {
  fetchFeatures();
});

function fetchFeatures() {
  loading.value = true;
  practitionerHttpService
    .get(`/api/internal/region-admin/center/${centerId.value}/features`)
    .then((response) => {
      features.value = response.data.all_features;
    })
    .catch(userErrorMessage)
    .finally(() => {
      loading.value = false;
    });
}

function saveFeatures() {
  practitionerHttpService
    .post(`/api/internal/region-admin/center/${centerId.value}/features`, {
      all_features: features.value,
    })
    .then(() => {
      savedCounter.value++;
      notify({
        text: lang.get("general.notificationSaved"),
        type: "success",
        duration: 1000,
      });
    })
    .catch(userErrorMessage);
}
</script>
